import React from 'react'
import CurrencyFormat from 'react-currency-format'

import { InputWrapper, Label, Error } from '../Field/styles'

const CurrencyField = ({
  name,
  label,
  error,
  labelWhite,
  onChange,
  classes,
  noMargin = false,
  ...props
}) => {
  return (
    <InputWrapper noMargin={noMargin}>
      {label && <Label white={labelWhite}>{label}:</Label>}
      <CurrencyFormat
        onValueChange={onChange}
        displayType="input"
        decimalSeparator=","
        thousandSeparator="."
        decimalScale={2}
        prefix="R$ "
        className={classes}
        {...props}
      />
      {error && <Error>{error}</Error>}
    </InputWrapper>
  )
}

export default CurrencyField
